// ─── Admin Route ───────────────────────────────────────────────────────────────
// Wraps a page that only company admins may open (e.g. Settings › Email Log).
// Managers are signed-in staff too, so ProtectedRoute alone is not enough; they are
// sent back to their own settings instead of seeing a page whose API would 403.
// The backend enforces the same rule (AuthPolicies.RequireAdmin) — this is UX, not security.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
  /** Where non-admins land. */
  fallbackPath?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children, fallbackPath = '/settings/security' }) => {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <Navigate to={fallbackPath} replace />;
  return <>{children}</>;
};

export default AdminRoute;
